
<div class="row">
    <div class="col-12">

        <!-- title -->
        <div class="title">
            <h5 *ngIf="!row_id"> Вы действительно хотите удалить выбранный справочник? </h5>
            <h5 *ngIf="row_id"> Вы действительно хотите удалить выбранный элемент справочника? </h5>
        </div>

        <!-- content -->
        <div class="content">

            <!-- info -->
            <div class="info">
                <ul *ngFor="let info of referencesInfo">
                    <li *ngIf="info.count != 0 && !row_id"> Справочник <b>{{ info.name }}</b> используется в {{ info.count }} атрибуте(ах) </li>
                    <li *ngIf="info.count != 0 && row_id"> Элемент справочника <b>{{ info.name }}</b> используется в {{ info.count }} товаре(ах) </li>
                </ul>
            </div>

        </div>

        <!-- buttons -->
        <div class="buttons">

            <!-- delete -->
            <button *ngIf="!row_id" type="button" class="btn btn-primary delete" (click)="referenceDelete()" [disabled]="referencesCount != 0">
                Удалить
            </button>

            <button *ngIf="row_id" type="button" class="btn btn-primary delete" (click)="refElementDelete()" [disabled]="referencesCount != 0">
                Удалить
            </button>

            <!-- close -->
            <button type="button" class="btn btn-secondary" (click)="activeModal.close()">
                Закрыть
            </button>

        </div>

    </div>
</div>

